module.exports = __webpack_public_path__ + "img/header-memoireRingsFullSizeMemoires.785b4ab.webp";